import { Component } from '@angular/core';
import { UserService } from '../../user.service';
import { UserProfileDialogComponent } from '../../user/profile/userprofile.component';
import { MatDialog } from '@angular/material/dialog';
import { UpdatePasswordDialogComponent } from '../../user/profile/update-password.component';
import { Router } from '@angular/router';


@Component({
  selector: 'app-nav-admin--menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavAdminMenuComponent {
  isExpanded = false;
  userFullName = '';
  isLoggedIn = false;
  isSteps = false;
  isSettings = false;
  isCountries = false;
  isProtection = false;
  isFilingRoutes = false;
  isTechFields = false;
  isEditUser = false;
  isUserInputs = false;
  currentUrl = window.location.href;

  constructor(private userService: UserService,
    public dialog: MatDialog, private router: Router)
  {
    this.userFullName = localStorage.getItem('email');
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  async checkCurrentPage() {

    if (this.currentUrl.toString().toLowerCase().includes("edit-step")) {
      this.isSteps = true;
      this.isSettings = false;
      this.isCountries = false;
      this.isProtection = false;
      this.isFilingRoutes = false;
      this.isTechFields = false;
      this.isEditUser = false;
      this.isUserInputs = false;
    }
    else if (this.currentUrl.toString().toLowerCase().includes("edit-map")) {
      this.isSteps = false;
      this.isSettings = true;
      this.isCountries = false;
      this.isProtection = false;
      this.isFilingRoutes = false;
      this.isTechFields = false;
      this.isEditUser = false;
      this.isUserInputs = false;
    }
    else if (this.currentUrl.toString().toLowerCase().includes("edit-country")) {
      this.isSteps = false;
      this.isSettings = false;
      this.isCountries = true;
      this.isProtection = false;
      this.isFilingRoutes = false;
      this.isTechFields = false;
      this.isEditUser = false;
      this.isUserInputs = false;
    }
    else if (this.currentUrl.toString().toLowerCase().includes("protection-type")) {
      this.isSteps = false;
      this.isSettings = false;
      this.isCountries = false;
      this.isProtection = true;
      this.isFilingRoutes = false;
      this.isTechFields = false;
      this.isEditUser = false;
      this.isUserInputs = false;
    }
    else if (this.currentUrl.toString().toLowerCase().includes("filing-route")) {
      this.isSteps = false;
      this.isSettings = false;
      this.isCountries = false;
      this.isProtection = false;
      this.isFilingRoutes = true;
      this.isTechFields = false;
      this.isEditUser = false;
      this.isUserInputs = false;
    }
    else if (this.currentUrl.toString().toLowerCase().includes("technical-field")) {
      this.isSteps = false;
      this.isSettings = false;
      this.isCountries = false;
      this.isProtection = false;
      this.isFilingRoutes = false;
      this.isTechFields = true;
      this.isEditUser = false;
      this.isUserInputs = false;
    }
    else if (this.currentUrl.toString().toLowerCase().includes("user-input")) {
      this.isSteps = false;
      this.isSettings = false;
      this.isCountries = false;
      this.isProtection = false;
      this.isFilingRoutes = false;
      this.isTechFields = false;
      this.isEditUser = false;
      this.isUserInputs = true;
    }
    else {

      this.isSteps = false;
      this.isSettings = false;
      this.isCountries = false;
      this.isProtection = false;
      this.isFilingRoutes = false;
      this.isTechFields = false;
      this.isEditUser = true;
      this.isUserInputs = false;
    }
  }

  async updateUserPassword(): Promise<void> {
    const dialogRef = this.dialog.open(UpdatePasswordDialogComponent, {
      width: '550px',
      data: {
        dialogTitle: 'Update Password',
        dialogMode: 'update',
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  async ngOnInit(): Promise<void>
  {
    this.checkCurrentPage();
  }
  logout() {
    this.userService.logout().subscribe(res => {
      localStorage.removeItem('token');
      localStorage.removeItem('email');
      this.router.navigateByUrl('/login');
    });
  }
  async updateUserProfile(): Promise<void> {
    await this.userService.getUserProfile().then(user => {
      const dialogRef = this.dialog.open(UserProfileDialogComponent, {
        width: '550px',
        data: {
          dialogTitle: 'Update Profile',
          dialogMode: 'update',
          user: user
        }
      });

      dialogRef.afterClosed().subscribe(result => {

      });
    }
    );
  }

}
